export default "__VITE_ASSET__Dpvvk724__"